/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import HeaderCheckBoxSelectList, { HeaderListProps } from './HeaderCheckBoxSelectList';

class HeaderCheckBoxSimpleList extends PureComponent<HeaderListProps> {
    handleChange = (numbers: Array<number> | string): void => {
        const { handleChange, fieldName } = this.props;
        handleChange(fieldName, numbers);
    };

    render(): React.ReactNode {
        const { elementList, fieldName, nullable } = this.props;
        if (!elementList) {
            return null;
        }

        return <HeaderCheckBoxSelectList handleChange={this.handleChange} elements={elementList} nullable={nullable} fieldName={fieldName} />;
    }
}

export default compose<any, any>(withStyles(adescomStyle))(HeaderCheckBoxSimpleList);
